import gql from "graphql-tag";

export const Mutation_StartTransaction = gql`
  mutation Mutation_StartTransaction(
    $seqId: Float!
    $transactionUUID: String!
    $cashfloatUid: String!
    $cashfloatSeqId: Float!
    $bookingUUID: String!
    $posRegisterId: String!
    $groupId: Float!
    $error: String
  ) {
    startTransaction(
      seqId: $seqId
      transactionUUID: $transactionUUID
      cashfloatUid: $cashfloatUid
      cashfloatSeqId: $cashfloatSeqId
      bookingUUID: $bookingUUID
      posRegisterId: $posRegisterId
      groupId: $groupId
      error: $error
    ) {
      seqId
      signature
    }
  }
`;

export const Mutation_CompleteTransaction = gql`
  mutation Mutation_CompleteTransaction(
    $seqId: Float!
    $transactionUUID: String!
    $cashfloatSeqId: Float!
    $bookingUUID: String!
    $posRegisterId: String!
    $groupId: Float!
    $receiptNumber: Float!
    $payments: [TransactionPaymentInput!]!
    $items: [TransactionItemInput!]!
    $error: String
    $completedAt: String
  ) {
    completeTransaction(
      seqId: $seqId
      transactionUUID: $transactionUUID
      cashfloatSeqId: $cashfloatSeqId
      bookingUUID: $bookingUUID
      posRegisterId: $posRegisterId
      groupId: $groupId
      receiptNumber: $receiptNumber
      payments: $payments
      items: $items
      error: $error
      completedAt: $completedAt
    ) {
      qrCodeData
      transactionEndTime
      signature
      closingTransaction
    }
  }
`;

export const Mutation_CloseCashPoint = gql`
  mutation Mutation_CloseCashPoint(
    $closureUuid: String!
    $posRegisterId: String!
    $cashfloatUid: String!
    $seqId: Float!
    $groupId: Float!
    $closedAt: String
  ) {
    closeCashPoint(
      closureUuid: $closureUuid
      posRegisterId: $posRegisterId
      cashfloatUid: $cashfloatUid
      seqId: $seqId
      groupId: $groupId
      closedAt: $closedAt
    ) {
      closureUUID
    }
  }
`;
